import { useContext } from 'react';
import { AddCastAndCrewContext } from './cast-and-crew.context';

export const useCastAndCrewContext = () => {
  const context = useContext(AddCastAndCrewContext);
  if (context === undefined) {
    throw new Error('useAddCastAndCrew must be used within a AddCastAndCrewProvider');
  }
  return context;
};
